module.exports = __webpack_public_path__ + "static/github-4a49c2efce959868aa8d0389b2c007fe.svg";